var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.84,
    height: 166.501,
    viewBox: "0 0 209.84 166.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162",
    "data-name": "Groupe 162",
    transform: "translate(-15.574 -5.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M272.857,716.409H481.9a.4.4,0,1,0,0-.8H272.857a.4.4,0,1,0,0,.8Z",
    transform: "translate(-256.884 -544.638)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_679",
    "data-name": "Trac\\xE9 679",
    d: "M556.454,237.719h-.91V212.78a14.434,14.434,0,0,0-14.434-14.434H488.274A14.434,14.434,0,0,0,473.84,212.78h0V349.6a14.434,14.434,0,0,0,14.434,14.434H541.11A14.434,14.434,0,0,0,555.544,349.6V255.471h.91Z",
    transform: "translate(-393.754 -193.076)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_680",
    "data-name": "Trac\\xE9 680",
    d: "M560.921,220.848V357.464a10.777,10.777,0,0,1-10.777,10.778H497.051a10.778,10.778,0,0,1-10.778-10.778V220.848A10.778,10.778,0,0,1,497.05,210.07h6.444a5.121,5.121,0,0,0,4.741,7.055h30.27a5.123,5.123,0,0,0,4.74-7.055h6.9a10.778,10.778,0,0,1,10.778,10.778h0Z",
    transform: "translate(-402.205 -201.045)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 16.47,
    height: 0.737,
    transform: "translate(88.091 22.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 16.47,
    height: 0.737,
    transform: "translate(113.157 22.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_681",
    "data-name": "Trac\\xE9 681",
    d: "M566.556,520.493H512.866a1.378,1.378,0,0,1,0-2.755h53.689a1.378,1.378,0,0,1,0,2.755Z",
    transform: "translate(-419.343 -410.153)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_682",
    "data-name": "Trac\\xE9 682",
    d: "M566.556,550.411H512.866a1.378,1.378,0,0,1,0-2.755h53.689a1.378,1.378,0,0,1,0,2.755Z",
    transform: "translate(-419.343 -430.487)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_683",
    "data-name": "Trac\\xE9 683",
    d: "M566.556,580.328H512.866a1.378,1.378,0,1,1,0-2.755h53.689a1.378,1.378,0,1,1,0,2.755Z",
    transform: "translate(-419.343 -450.821)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 16.47,
    height: 0.737,
    transform: "translate(138.223 22.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 16.47,
    height: 0.737,
    transform: "translate(88.091 154.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 16.47,
    height: 0.737,
    transform: "translate(113.157 154.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 16.47,
    height: 0.737,
    transform: "translate(138.223 154.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 24.966,
    cy: 24.966,
    r: 24.966,
    transform: "translate(96.426 41.538)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 22.776,
    cy: 22.776,
    r: 22.776,
    transform: "translate(98.616 44.833)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_684",
    "data-name": "Trac\\xE9 684",
    d: "M582.521,382.369c-.049,0-.1,0-.149,0a3.033,3.033,0,0,1-2.248-1.169l-3.59-4.615a3.039,3.039,0,0,1,.532-4.261l.129-.1a3.041,3.041,0,0,1,4.262.532,1.821,1.821,0,0,0,1.35.7,1.786,1.786,0,0,0,1.412-.566l7.289-7.694a3.04,3.04,0,0,1,4.292-.116l.119.112a3.04,3.04,0,0,1,.117,4.293l-11.31,11.938a3.031,3.031,0,0,1-2.2.948Z",
    transform: "translate(-463.118 -305.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 2.949,
    height: 15.85,
    transform: "translate(78.553 31.563)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 2.949,
    height: 9.215,
    transform: "translate(78.553 49.257)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 2.949,
    height: 9.215,
    transform: "translate(78.553 60.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1.474,
    cy: 1.474,
    r: 1.474,
    transform: "translate(105.462 9.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_685",
    "data-name": "Trac\\xE9 685",
    d: "M554.462,409.278a22.773,22.773,0,0,1-22.714-21.17c-.037.527-.063,1.061-.063,1.6a22.776,22.776,0,0,0,45.553,0c0-.54-.026-1.073-.062-1.6a22.773,22.773,0,0,1-22.714,21.173Z",
    transform: "translate(-433.07 -322.047)",
    fill: "#231f20",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_686",
    "data-name": "Trac\\xE9 686",
    d: "M479.182,234.015l18.062.737,2.212-12.164L483.974,217.8Z",
    transform: "translate(-325.679 -148.026)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_687",
    "data-name": "Trac\\xE9 687",
    d: "M659.084,336.678l.175-5.747-8.754-2.195-15.761-4.6a3.29,3.29,0,1,0-1.756,4.022l15.322,6.3Z",
    transform: "translate(-498.754 -277.036)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_688",
    "data-name": "Trac\\xE9 688",
    d: "M706.725,353.05l4.924-7.024.123.016a104.894,104.894,0,0,1,12.863,2.551,4.047,4.047,0,0,1,2.621,2.179,4.245,4.245,0,0,1-.59,4.616,4.54,4.54,0,0,1-4.666,1.55Z",
    transform: "translate(-552.037 -293.448)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_689",
    "data-name": "Trac\\xE9 689",
    d: "M476.937,477.466h-5.009l-2.383-19.321h7.393Z",
    transform: "translate(-319.129 -311.381)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_690",
    "data-name": "Trac\\xE9 690",
    d: "M592.739,471.158l-4.953.749-5.245-18.748,6.493-1.1Z",
    transform: "translate(-395.928 -307.241)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_691",
    "data-name": "Trac\\xE9 691",
    d: "M709.985,434.86l-17.325-2.949-.616,1.27a58.833,58.833,0,0,0-5.765,21.851c-.418,6.406-.664,13.171-.672,20.263-.012,10.988.548,21.184,1.435,30.461l9.508-.06a224.6,224.6,0,0,1,1.12-29.508c.728-6.989,1.74-13.517,2.91-19.541a134.423,134.423,0,0,0,9.143,25.667c3.323,7.027,10.158,15.15,13.48,22.177l10.215-1.226c-2.683-7.1-7.47-17.458-10.153-24.554-3.837-10.146-5.57-17.025-9.406-27.171a31.262,31.262,0,0,0,.128-5.746c-.179-3.192-.843-7.022-2.784-9.576Z",
    transform: "translate(-537.683 -351.82)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_692",
    "data-name": "Trac\\xE9 692",
    d: "M728.036,371.042c.865,1.617-1.19,4.968-2.676,5.289l-17.133-5.538,8.627-25,4.34.789,6.941,1.169,2.462,2.238a4.329,4.329,0,0,1,1.194,4.569Z",
    transform: "translate(-553.057 -293.291)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_693",
    "data-name": "Trac\\xE9 693",
    d: "M675.453,387.888l-4.847-3.093-6.368,6.4-12.02,11.183a3.29,3.29,0,1,0,2.555,3.568l13.256-9.935Z",
    transform: "translate(-512.268 -319.797)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_694",
    "data-name": "Trac\\xE9 694",
    d: "M716.672,369.583l-3.511-7.826.077-.1a104.924,104.924,0,0,1,8.778-9.742,4.047,4.047,0,0,1,3.213-1.135,4.247,4.247,0,0,1,3.663,2.871,4.539,4.539,0,0,1-1.057,4.8Z",
    transform: "translate(-556.411 -296.668)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 7.62,
    cy: 7.62,
    r: 7.62,
    transform: "translate(163.563 35.595)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_695",
    "data-name": "Trac\\xE9 695",
    d: "M743.589,307.774l-.029-.007L732.487,305a2.531,2.531,0,0,1-1.556-3.759l.366-.609a4.151,4.151,0,0,0,.17-3.965,4.371,4.371,0,0,0-2.513-2.147l-.037-.018-.233-.145a1.814,1.814,0,0,1-.96-1.11,1.872,1.872,0,0,1,.183-1.51,9.161,9.161,0,0,1,4.185-3.69,9.448,9.448,0,0,1,6.944-.209,1.233,1.233,0,0,1,1.134-.288c5.734,1.389,6.206,5.238,5.074,11.416l1.341,5.408a2.71,2.71,0,0,1-2.417,3.354ZM738.976,287.9h0Zm.138-.034h0Z",
    transform: "translate(-566.253 -253.518)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_696",
    "data-name": "Trac\\xE9 696",
    d: "M690.648,694.736H687.79l-.51-2.7-1.307,2.7H678.39a1.7,1.7,0,0,1-.969-3.107l6.055-4.182v-2.729l6.369.38Z",
    transform: "translate(-531.62 -523.643)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_697",
    "data-name": "Trac\\xE9 697",
    d: "M811.08,694.736h-2.859l-.51-2.7-1.307,2.7h-7.582a1.7,1.7,0,0,1-.968-3.107l6.055-4.182v-2.729l6.369.38Z",
    transform: "translate(-613.472 -523.643)",
    fill: "#2f2e41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.2dd1fccc.svg";
export { ForwardRef as ReactComponent };